/**
 * 优惠明细弹层优惠种类枚举
 *  类型：
 * 预估到手 1
 * 商品总额 2
 * 共优惠 6
 * 首单立减 7
 * 优惠券 8
 * 满减 9
 * 下单立减 10
 */
export const DISCOUNT_TYPE = {
  PREDICT_PRICE: 1, // 预估到手价
  GOODS_TOTAL_PRICE: 2, // 商品总额
  DISCOUNT_TOTAL_PRICE: 6, // 共优惠价格
  FIRST_ORDER_DISCOUNT: 7, // 首单立减
  DISCOUNT_COUPON: 8, // 优惠券
  FULL_REDUCTION: 9, // 满减
  ORDER_REDUCTION: 10, // 下单立减
};

/**
 * 优惠明细按钮类型
 * 2023.5.24 分两种： 领券结算、去结算(普通结算)
 */
export const CHECKOUT_BTN_TYPE = {
  NORMAL_CHECKOUT: 0, // 普通结算
  GET_COUPON_CHECKOUT: 1, // 领券结算
};

/**
 * 终端类型
 */
export const TERMINAL = {
  PC: "1",
  WAP: "2",
  APP: "3",
  WX: "4",
};

/**
 * 平台类型
 */
export const WEBSITE_TYPE = {
  lenovo: 1,
  lecoo: 18,
  epp: 3,
};
